import * as React from "react";
import type { SVGProps } from "react";
const SvgDirectionleftIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="directionleft_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M316.245 469.419 542.08 243.584a42.667 42.667 0 1 0-60.33-60.33L183.38 481.62a43.093 43.093 0 0 0 0 60.928l298.37 298.369a42.667 42.667 0 0 0 60.331-60.33L316.245 554.752h496.982c22.101 0 40.021-19.115 40.021-42.667s-17.92-42.666-40.021-42.666H316.245z"
    />
  </svg>
);
export default SvgDirectionleftIcon;
